const pencilIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" class="icon-pencil">
  <path class="icon-pencil" fill="none" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" d="M6.07833333 18.0625L.69 19.3266667 1.95416667 13.9391667 14.9541667.9375C15.605.286666667 16.6616667.286666667 17.3116667.9375L19.08 2.70583333C19.73 3.35666667 19.73 4.41166667 19.08 5.06333333L6.07833333 18.0625zM18.4925 5.65333333L14.365 1.52666667M17.3033333 6.8425L13.1866667 2.705M6.28833333 17.8533333L2.16333333 13.7283333" transform="translate(0 1)"/>
</svg>
`;

export default pencilIcon;
